var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDelivery = function SvgDelivery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 6H13.8L13.8 10.8447H19.65M19.65 10.8447L21 12.1863V16.2112H18.6755M19.65 10.8447L18.9154 8.6546C18.5479 7.55892 17.5161 6.81988 16.354 6.81988H13.8M18.6755 16.2112C18.6755 17.1991 17.8696 18 16.8755 18C15.8814 18 15.0755 17.1991 15.0755 16.2112M18.6755 16.2112C18.6755 15.2232 17.8696 14.4224 16.8755 14.4224C15.8814 14.4224 15.0755 15.2232 15.0755 16.2112M15.0755 16.2112H10.0033M10.0033 16.2112C10.0033 17.1991 9.19738 18 8.20327 18C7.20915 18 6.40327 17.1991 6.40327 16.2112M10.0033 16.2112C10.0033 15.2232 9.19738 14.4224 8.20327 14.4224C7.20915 14.4224 6.40327 15.2232 6.40327 16.2112M6.40327 16.2112H4.80002V13.4534M7.5 10.9689H3M9 8.48447H4.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgDelivery;